import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
export const generateFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[],
  idx1: number
): ModuleFields[] => {
  return languages.flatMap((lang) => [
    {
      fieldName: `Tab Name (${lang.code})`,
      fieldValue: `${basePath}.items[${idx1}].tab.name`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}.${basePath}.items[${idx1}].tab.name`,
      formType: "input",
      label: `Tab Name (${lang.code})`,
      placeholder: `Enter Tab Name ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Tab Name ${lang.code} is required` } : undefined,
    },
    {
      fieldName: `Body (${lang.code})`,
      fieldValue: `${basePath}.items[${idx1}].body`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}.${basePath}.items[${idx1}].body`,
      formType: "richText",
      label: `Body (${lang.code})`,
      placeholder: `Enter Body ${lang.code}`,
      validation:
        lang.parseField === "field_content_english" ? { required: `Body ${lang.code} is required` } : undefined,
    },
  ]);
};
export const languages = [
  { code: "EN", label: "English", parseField: "field_content_english" },
  { code: "MS", label: "Malay", parseField: "field_content_malay" },
  { code: "ZH", label: "Mandarin", parseField: "field_content_mandarin" },
];
let url = `/api/page-content/all-fields?pageName=about-us/corporate-profile/our-profile`;
export let getData: { [key in ModuleConfig]: ModuleFields[] } | null = null;
const fetchProfileData = async (): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    const res = await corporateCMSApi.get(url);
    const profileData = res.data;
    const fields1 =
      profileData?.[0]?.field_content_english?.data?.items?.map((item: any, index: number) =>
        generateFields("data", languages, index)
      ) || [];
    return {
      ourProfile: fields1 as ModuleFields[],
    };
  } catch (error) {
    return null;
  }
};
export const getOurProfileDrillDownData = async () => {
  if (!getData) {
    getData = await fetchProfileData();
  }
  return getData;
};

// export const getOurProfileDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
//   ourProfile: [
//     {
//       fieldName: "Body (EN)",
//       fieldValue: "data.items[0].body",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "text",
//       name: "field_content_english_our_story",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter content English Our Story",
//       validation: { required: "Content English Our Story is required" },
//     },
//     {
//       fieldName: "Body (EN)",
//       fieldValue: "data.items[1].body",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "text",
//       name: "field_content_english_our_business",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter content English Our Business",
//       validation: { required: "Content English Our Business is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content Next Page Name (EN)",
//       validation: { required: "Content Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content Next Page Link (EN)",
//       validation: { required: "Content Next Page Link (EN) is required" },
//     },
//     {
//       fieldName: "Timeline Frame (EN)",
//       fieldValue: "data.timelineFrame",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_timeline_frame",
//       formType: "input",
//       label: "Timeline Frame (EN)",
//       placeholder: "Enter timeline frame URL",
//       // validation: { required: "Timeline frame URL is required" },
//     },

//     {
//       fieldName: "Body (MS)",
//       fieldValue: "data.items[0].body",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "text",
//       name: "field_content_malay_our_story",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter content Malay Our Story",
//       // validation: { required: "Content Malay Our Story is required" },
//     },
//     {
//       fieldName: "Body (MS)",
//       fieldValue: "       data.items[1].body",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "text",
//       name: "field_content_malay_our_business",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter content Malay Our Business",
//       // validation: { required: "Content Malay Our Business is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter Next Page Name (MS)",
//       // validation: { required: "Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter Next Page Link (MS)",
//       // validation: { required: "Next Page Link (MS) is required" },
//     },
//     {
//       fieldName: "Timeline Frame (MS)",
//       fieldValue: "data.timelineFrame",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_timeline_frame",
//       formType: "input",
//       label: "Timeline Frame (MS) (MS)",
//       placeholder: "Enter timeline frame URL",
//       // validation: { required: "Timeline frame URL is required" },
//     },

//     {
//       fieldName: "Body (ZH)",
//       fieldValue: "data.items[0].body",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "text",
//       name: "field_content_mandarin_our_story",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter content Mandarin Our Story",
//       validation: { required: "Content Mandarin Our Story is required" },
//     },
//     {
//       fieldName: "Body (ZH)",
//       fieldValue: "data.items[1].body",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "text",
//       name: "field_content_mandarin_our_business",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter content Mandarin Our Business",
//       // validation: { required: "Content Mandarin Our Business is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter Next Page Name (ZH)",
//       // validation: { required: "Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter Next Page Link (ZH)",
//       // validation: { required: "Next Page Link (ZH) is required" },
//     },
//     {
//       fieldName: "Timeline Frame (ZH)",
//       fieldValue: "data.timelineFrame",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_timeline_frame",
//       formType: "input",
//       label: "Timeline Frame (ZH)",
//       placeholder: "Enter timeline frame URL",
//       // validation: { required: "Timeline frame URL is required" },
//     },
//   ],
//   ourStory: [
//     {
//       fieldName: "Body (EN)",
//       fieldValue: "data.items[0].body",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_our_story",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter content English Our Story",
//       validation: { required: "Content English Our Story is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content Next Page Name (EN)",
//       validation: { required: "Content Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content Next Page Link (EN)",
//       validation: { required: "Content Next Page Link (EN) is required" },
//     },
//     {
//       fieldName: "Timeline Frame (EN)",
//       fieldValue: "data.timelineFrame",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_timeline_frame",
//       formType: "input",
//       label: "Timeline Frame (EN)",
//       placeholder: "Enter timeline frame URL",
//       // validation: { required: "Timeline frame URL is required" },
//     },
//     {
//       fieldName: "Body (MS)",
//       fieldValue: "data.items[0].body",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_our_story",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter content Malay Our Story",
//       // validation: { required: "Content Malay Our Story is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter Next Page Name (MS)",
//       // validation: { required: "Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter Next Page Link (MS)",
//       // validation: { required: "Next Page Link (MS) is required" },
//     },
//     {
//       fieldName: "Body (ZH)",
//       fieldValue: "data.items[0].body",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_our_story",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter content Mandarin Our Story",
//       // validation: { required: "Content Mandarin   Our Story is required" },
//     },
//     {
//       fieldName: "Timeline Frame (MS)",
//       fieldValue: "data.timelineFrame",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_timeline_frame",
//       formType: "input",
//       label: "Timeline Frame (MS)",
//       placeholder: "Enter timeline frame URL",
//       // validation: { required: "Timeline frame URL is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter Next Page Name (ZH)",
//       // validation: { required: "Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter Next Page Link (ZH)",
//       // validation: { required: "Next Page Link (ZH) is required" },
//     },
//     {
//       fieldName: "Timeline Frame (ZH)",
//       fieldValue: "data.timelineFrame",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_timeline_frame",
//       formType: "input",
//       label: "Timeline Frame (ZH)",
//       placeholder: "Enter timeline frame URL",
//       // validation: { required: "Timeline frame URL is required" },
//     },
//   ],
//   ourBusiness: [
//     {
//       fieldName: "Body (EN)",
//       fieldValue: "data.items[1].body",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_our_business",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter content English Our Business",
//       validation: { required: "Content English Our Business is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content Next Page Name (EN)",
//       validation: { required: "Content Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content Next Page Link (EN)",
//       validation: { required: "Content Next Page Link (EN) is required" },
//     },
//     {
//       fieldName: "Timeline Frame (EN)",
//       fieldValue: "data.timelineFrame",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_timeline_frame",
//       formType: "input",
//       label: "Timeline Frame (EN)",
//       placeholder: "Enter timeline frame URL",
//       // validation: { required: "Timeline frame URL is required" },
//     },
//     {
//       fieldName: "Body (MS)",
//       fieldValue: "data.items[1].body",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_our_business",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter content Malay Our Business",
//       // validation: { required: "Content Malay Our Business is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter Next Page Name (MS)",
//       // validation: { required: "Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter Next Page Link (MS)",
//       // validation: { required: "Next Page Link (MS) is required" },
//     },
//     {
//       fieldName: "Timeline Frame (MS)",
//       fieldValue: "data.timelineFrame",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_timeline_frame",
//       formType: "input",
//       label: "Timeline Frame (MS)",
//       placeholder: "Enter timeline frame URL",
//       // validation: { required: "Timeline frame URL is required" },
//     },
//     {
//       fieldName: "Body (ZH)",
//       fieldValue: "data.items[1].body",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_our_business",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter content Mandarin Our Business",
//       // validation: { required: "Content Mandarin Our Business is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter Next Page Name (ZH)",
//       // validation: { required: "Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter Next Page Link (ZH)",
//       // validation: { required: "Next Page Link (ZH) is required" },
//     },
//     {
//       fieldName: "Timeline Frame (ZH)",
//       fieldValue: "data.timelineFrame",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_timeline_frame",
//       formType: "input",
//       label: "Timeline Frame (ZH)",
//       placeholder: "Enter timeline frame URL",
//       // validation: { required: "Timeline frame URL is required" },
//     },
//   ],
// };
